import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'
import Haku from './views/Haku.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/haku',
      name: 'haku',
      component: Haku
    }
  ]
})
